/**
 * The Overview's **Preview** on *For the crew · 9* — `docs/visit-page.md`
 * §7.8, §13.4: the crew iPad's card for this visit, as the crew lead sees it
 * this morning, read from For the crew's own endpoint (whose `preview` is the
 * crew app's read, made as the lead). The same card the tab draws on its
 * right; here in Slice 6's `VisitCard`, or Board 16 D's sheet on a phone.
 */
import type { ForCrewRead, VisitRead } from '@rowted/shared'
import { useVisitTab } from './api.js'
import { VisitCard, VisitTile } from './sheet.js'
import { CrewIpadCardView } from './crew-ipad-card.js'
import { CREW_PREVIEW } from './copy.js'

export function CrewPreviewSheet({
  visitId, read, onClose, onOpenTab,
}: {
  visitId: string
  read: VisitRead
  onClose: () => void
  /** Plans and Map open For the crew's files and maps; Load list opens Materials by day. */
  onOpenTab?: (key: 'for-crew' | 'materials') => void
}) {
  const { data } = useVisitTab<ForCrewRead>(visitId, '/for-crew')
  const viewer = data?.preview.viewer ?? read.header.meta.crew?.lead ?? null
  return (
    <VisitCard
      width={448}
      title={viewer ? CREW_PREVIEW.title(viewer.firstName) : CREW_PREVIEW.when}
      {...(viewer ? { sub: CREW_PREVIEW.when } : {})}
      mark={<VisitTile glyph="clipboard" tone="teal" size={36} />}
      onClose={onClose}
    >
      {data && (
        <CrewIpadCardView
          card={data.preview}
          onPlans={() => { onClose(); onOpenTab?.('for-crew') }}
          onMap={() => { onClose(); onOpenTab?.('for-crew') }}
          onLoadList={() => { onClose(); onOpenTab?.('materials') }}
        />
      )}
    </VisitCard>
  )
}
